import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'aa-filter-sub-title',
    templateUrl: './filter-sub-title.component.html',
    styleUrls: [
        './filter-sub-title.component.scss'
    ],
    standalone: false
})
export class FilterSubTitleComponent implements OnInit
{
    @Input() isFirst: boolean = false;

    constructor() { }

    ngOnInit ()
    {
    }
}
